// extracted by mini-css-extract-plugin
export default {"blockTitle":"BlockTitle_blockTitle"};